import AppHeader from '@/views/layout/AppHeader';
import AppMain from '@/views/layout/AppMain';
import AppFooter from '@/views/layout/AppFooter';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
export default {
  name: 'App',
  components: {
    AppHeader,
    AppMain,
    AppFooter
  },
  data() {
    return {
      zhCN
    };
  },
  methods: {
    // 当账号冻结滚动提示
    move(e) {
      if (e <= 1) {
        let total = document.querySelector('.app-wrapper__header').getBoundingClientRect().width || '';
        let tip = document.querySelector('.top-tips');
        let lefts = 0;
        tip.style.visibility = 'visible';
        // eslint-disable-next-line no-unused-vars
        let timer = requestAnimationFrame(function fn() {
          lefts = tip.offsetLeft;
          if (lefts < total) {
            tip.style.left = `${lefts + 1}px`;
            requestAnimationFrame(fn);
          } else {
            tip.style.left = `${-762}px`;
            requestAnimationFrame(fn);
          }
        });
      } else {
        let tip = document.querySelector('.top-tips');
        tip.style.visibility = 'visible';
      }
    },
    stopMove() {
      let tip = document.querySelector('.top-tips');
      tip.style.visibility = 'hidden';
    }
  }
};